module.exports = __webpack_public_path__ + "static/media/home-background-banner.46e52e53.jpg";